import {ListCitiesResponseDto} from '@features/setting/application/use_cases/list-cities/dto/list-cities.response.dto';
import {ListCitiesPayloadDto} from '@features/setting/application/use_cases/list-cities/dto/list-cities.payload.dto';

import {
  ListCitiesHttpResponseDto
} from '@features/setting/infrastructure/http/list-cities/list-cities.http.response.dto';
import {ListCitiesHttpPayloadDto} from '@features/setting/infrastructure/http/list-cities/list-cities.http.payload.dto';

export class ListCitiesHttpMapper {

  static toResponse(data: ListCitiesHttpResponseDto): ListCitiesResponseDto {
    return {
      data: data.data.map(item => ({
        id: item.code,
        code: item.code,
        label: item.name,
        state_code: item.state_code,
      }))
    }
  }

  static toInfra(data: ListCitiesPayloadDto): ListCitiesHttpPayloadDto {
    return {}
  }

}
